import React from "react";

import StepperActions from "../../components/StepperActions";

const Four = () => (
    <>
        <StepperActions activeStep={3}/>

        Step Four
    </>
);

export default Four;
